import { __extends } from "tslib";
import { UserVipInfo } from '../../base/common/value-objects/user-vip-info/user-vip-info';
import { ValueObject } from '../../base/ddd-types/value-object';
var DocOwnerInfo = /** @class */ (function (_super) {
    __extends(DocOwnerInfo, _super);
    function DocOwnerInfo(jsonObj) {
        var _this = _super.call(this) || this;
        _this.ownerId = '';
        _this.ownerAppid = '';
        _this.ownerNick = '';
        _this.ownerAvatar = '';
        _this.officialAuthInfo = {
            avatar: '',
            credential: '',
            introduction: '',
            nick: '',
            principal: '',
        };
        _this.vipLevel = 1 /* EVipLevel.Inactive */;
        _this.vipInfo = new UserVipInfo({});
        _this.jsonObj2Class(jsonObj);
        return _this;
    }
    return DocOwnerInfo;
}(ValueObject));
export { DocOwnerInfo };
